import { DID_CLASS, DID_TYPE } from "voxloud-types/dist/models";


export enum DID_PORTABILITY_STATUS {
  ONGOING = 'ONGOING',
  COMPLETED = 'COMPLETED'
}

export interface PortabilityRequestResponse {
  company_id: number;
  creation_date: Date;
  dids: {
    number: string;
    class: DID_CLASS,
    type: DID_TYPE
  }[];
  documents: PortabilityDocs[];
  id: number;
  status: DID_PORTABILITY_STATUS;
  update_date: Date;
}

interface PortabilityDocs {
  documentType: string;
  documentUrl: string;
  id: number;
}
